import React, { useEffect } from 'react';
import { useSingleEffect } from 'react-haiku';
import { useCollect } from 'hooks';

import Progress from 'components/Misc/Progress';
import { Title } from 'components/Misc/Typography';

import Child from 'containers/Parent/Marks/Read/Child';

import { useAppStore } from 'store/useAppStore';
import { useParentMarkStore } from 'store/parent/useParentMarkStore';

// Store request parameters
const parameters = {
	eager: '[children.[grades.program, courses.subject, takes.exam, marks.subject]]'
};

const Read = () => {
	// Use app's store
	const id = useAppStore(state => state.user.id);

	// Use student's mark store
	const [children, onInit, onReset] = useParentMarkStore(state => [
		state.children,
		state.onInit,
		state.onReset
	]);

	// Store requested user
	const [[, progress], collect] = useCollect(`users/${id}`, parameters, onInit);

	// Collect user on mount and on parameter change
	useSingleEffect(() => {
		(async () => await collect())();
	});

	// Reset state on unmount
	useEffect(() => {
		return () => onReset();
	}, []);

	return (
		<div className="space-y-4">
			<Title
				title="Sekmes"
				className="text-2xl"
			/>

			<Progress progress={progress} />

			{children.map(child =>
				<Child key={child.id} child={child} />
			)}
		</div>
	);
};

export default Read;